import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SpecialRequestField} from './special-request-field.model';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';
import {Filter} from '../models/warranties/filter.model';
import {SpecialRequest} from './special-request.model';

@Injectable({
  providedIn: 'root'
})
export class SpecialRequestService {

  _userSpecialRequests: Array<SpecialRequest>;
  filter: Filter = new Filter();

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  specialRequestFields(): Observable<Array<SpecialRequestField>> {
    return this.httpClient.get<Array<SpecialRequestField>>(`${environment.baseUrl}/specialRequestFields`, this.headers());
  }

  saveSupportingDocument(file: File): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<string>(`${environment.baseUrl}/saveSupportingDocument`, formData);
  }

  downloadSupportingMaterial(id: number): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}/downloadSpecialRequestSupportingMaterial/${id}`, {
      headers: this.headers().headers, responseType: 'blob'
    });
  }

  headers() {
    return {headers: this.authService.getHeaders()};
  }

  fetchSpecialRequests(filter: Filter): Observable<Array<SpecialRequest>> {
    return this.httpClient.post<Array<SpecialRequest>>(`${environment.baseUrl}/specialrequests`, filter, this.headers());
  }

  readMessage(id: number) {
    return this.httpClient.put(`${environment.baseUrl}/specialrequests/readmessage/${id}`, this.filter, this.headers());
  }

  public set specialRequests(specialRequests: Array<SpecialRequest>) {
    this._userSpecialRequests = specialRequests;
  }

  public get specialRequests(): Array<SpecialRequest> {
    return this._userSpecialRequests;
  }
}
